/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { RichTextComponent } from '@msdyn365-commerce/core';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import * as React from 'react';
import { IProductSkutitleData } from './product-skutitle.data';
import { IProductSkutitleProps } from './product-skutitle.props.autogenerated';

/**
 *
 * ProductSkutitle component
 * @extends {React.PureComponent<IProductSkutitleProps<IProductSkutitleData>>}
 */
class ProductSkutitle extends React.PureComponent<IProductSkutitleProps<IProductSkutitleData>> {
  private _productAttributeWineBottleSize: string = 'WINE BOTTLE SIZE';
  public render(): JSX.Element | null {
    const content: IProductSkutitleData = this.props.data;
    if (!(content && content.productSpecificationData && content.productSpecificationData.result)
    ) {
      return null;
    }
    const productAttributes = content.productSpecificationData.result;
    const productAttribute = productAttributes.filter(
      attribute => attribute.Name && attribute.Name.toUpperCase() === this._productAttributeWineBottleSize
    );
    if (
      productAttribute &&
      productAttribute.length &&
      productAttribute[0].TextValue
    ) {
      // DG: Removed hard-coded bottle text. Some 14 Hands SKUs are cans.
      // In the future, add a mechanism to identify bottles, or just include the bottle text in the back-end.
      //      const skuTitle = productAttribute[0].TextValue.concat(' bottle');// need to followup for localization
      const skuTitle = productAttribute[0].TextValue;

      return (
        <div className='product-attribute'>
          <RichTextComponent
            className='product-attribute-skutitle'
            text={skuTitle}
          />
        </div>
      );
    } else {
      const productDetails: SimpleProduct | undefined = content.product && content.product.result;
      if (
        productDetails &&
        productDetails.Name
      ) {
        return (
          <div className='product-attribute'>
            <RichTextComponent
              className='product-attribute'
              text={productDetails.Name}
            />
          </div>
        );
      }
    }
    return null;
  }
}
export default ProductSkutitle;
